import React, { useState } from "react";
import styles from "./EmailRechargePlans.module.css";
import { emailRechangePlans } from "../../Components/mockData";
import { Link } from "react-router-dom";
import PlanCard from "../../Components/PlanCard/PlanCard";
import CenteredPopUp from "../../Components/CenteredPopUp/CenteredPopUp";
import AutomaticBillPayementContent from "../AutomaticBillPayementContent/AutomaticBillPayementContent";
import AutomaticBillSetUpContent from "../AutomaticBillSetUpContent/AutomaticBillSetUpContent";
import RechargeProcessingContent from "../RechargeProcessingContent/RechargeProcessingContent";
import RechargeResultContent from "../RechargeResultContent/RechargeResultContent";


interface EmailRechargePlansProps { }


const EmailRechargePlans: React.FC<EmailRechargePlansProps> = () => {
  const [activeFilters, setActiveFilters] = useState<string[]>([]);
  const [openTryAutoPayModal, setOpenTryAutoPayModal] = useState<boolean>(false);
  const [openSetUpAutoPayModal, setOpenSetUpAutoPayModal] = useState<boolean>(false);
  const [openRechargeProcessing, setOpenRechargeProcessing] = useState<boolean>(false);
  const [rechargeResult, setRechargeResult] = useState<boolean>(false);

  const handleFilterClick = (filter: string) => {
    setActiveFilters((prevFilters) => {
      if (prevFilters.includes(filter)) {
        return prevFilters.filter((f) => f !== filter);
      } else {
        return [...prevFilters, filter];
      }
    });
  };

  const onClickHandler = () => {
    setOpenTryAutoPayModal(true);
    document.body.classList.add("no-overflow");
  };

  return (
    <div className={`${styles.WhatsRechPlan} ${styles.Parent}`}>
      <div className={styles.RechPlanHeader}>
        <div className={styles.RechPlanHeaderInner}>
          <div className={styles.RechPlanHeaderTitle}><span className={"TextBold"}>Recharge</span> Email Subscription</div>
          <div className={'Breadcrums'}>
            <span className={"BreadcrumsPath"}>Subscription</span>
            <span className={"BreadcrumsPath"}>Email</span>
          </div>
        </div>
        <Link to={'/rechargeTransactionHistory'} className={"CtaOutlined"}>Recharge History</Link>
      </div>
      <div className={styles.AutoPaydetails}>
        <div className={styles.AutoPaydetailsInner}>
          <div className={styles.AutoPaydetailTitle}>Autopay Details</div>
          <div className={styles.AtmbilpayBillCard}>
            <div className={styles.PlanCardInfo}>
              <div className={styles.PlanCardInfoi}>
                <div className={styles.PlanCardLabel}>Plan</div>
                <div className={styles.PlanCardData}>42000</div>
              </div>
              <div className={styles.PlanCardInfoi}>
                <div className={styles.PlanCardLabel}>Validity</div>
                <div className={styles.PlanCardData}>365 Days</div>
              </div>
              <div className={styles.PlanCardInfoi}>
                <div className={styles.PlanCardLabel}>Recharge Balance</div>
                <div className={styles.PlanCardData}>50000 Credits</div>
              </div>
              <div className={styles.PlanCardInfoi}>
                <div className={styles.PlanCardLabel}>Remaining balance</div>
                <div className={`${styles.PlanCardData} ${styles.PlanCardDataRb}`}>50 Credits</div>
              </div>
            </div>
            <div className={styles.TermsWrap}>
              <div className={styles.Terms}>
                Bill is paid automatically every <span className={styles.TextBold}>90 Days</span> , Next bill of ₹42000 is due on <span className={styles.TextBold}>29 November 2024</span>
              </div>
              <div className={styles.AtmbilpayActns}>
                <span className={`${styles.AtmbilpayCtaFilled} CtaFilled`}>Change Plan</span>
                <span className={`${styles.AtmbilpayCtaOutlined} CtaOutlined`}>Cancel Autopay</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.RechPlanLayout}>
        <div className={styles.RechPlanTitle}>Topup plans
        </div>
        <div className={styles.PlanCards}>
          {
            emailRechangePlans?.map((plan, index) => {
              return (
                <PlanCard
                  key={index}
                  isTopup={plan.isTopup}
                  isPopular={plan.isPopular}
                  isBestValue={plan.isBestValue}
                  oAmount={plan.originalValue}
                  newAmount={plan.discountedValue}
                  discount={plan.discountPercent}
                  validity={plan.validity}
                  balance={plan.balance}
                  linkTo={null}
                  ctaText="Recharge"
                  onClick={onClickHandler}
                />
              )
            })
          }
        </div>
        {
          openTryAutoPayModal &&
          <CenteredPopUp
            setModal={setOpenTryAutoPayModal}
            children={
              <AutomaticBillPayementContent
                setOpenSetUpAutoPayModal={setOpenSetUpAutoPayModal}
                PayModal={setOpenTryAutoPayModal}
              />
            }
            modiferClass={styles.Tabp}
            closeIcon={false}
          />
        }
        {
          openSetUpAutoPayModal &&
          <CenteredPopUp
            setModal={setOpenSetUpAutoPayModal}
            children={
              <AutomaticBillSetUpContent
                setOpenSetUpAutoPayModal={setOpenSetUpAutoPayModal}
                setOpenRechargeProcessing={setOpenRechargeProcessing}
              />
            }
            modiferClass={styles.Tabp}
            closeIcon={false}
          />
        }
        {
          openRechargeProcessing &&
          <CenteredPopUp
            setModal={setOpenRechargeProcessing}
            children={
              <RechargeProcessingContent
                setOpenRechargeProcessing={setOpenRechargeProcessing}
                setRechargeResult={setRechargeResult}
              />
            }
            modiferClass={styles.Tabp}
            closeIcon={false}
          />
        }
        {
          rechargeResult &&
          <CenteredPopUp
            setModal={setRechargeResult}
            children={
              <RechargeResultContent
                setRechargeResult={setRechargeResult}
              />
            }
            modiferClass={styles.Tabp}
            closeIcon={false}
          />
        }
      </div>
    </div>
  );
};

export default EmailRechargePlans;